import { render, staticRenderFns } from "./wxInner.vue?vue&type=template&id=7cc7394b&scoped=true"
import script from "./wxInner.vue?vue&type=script&lang=js"
export * from "./wxInner.vue?vue&type=script&lang=js"
import style0 from "./wxInner.vue?vue&type=style&index=0&id=7cc7394b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc7394b",
  null
  
)

export default component.exports